import { type ScopeContext } from "@sentry/core"

export type ErrorTrackingContext = Pick<ScopeContext, "extra" | "tags">

let globalContext: Partial<ErrorTrackingContext> | undefined = undefined

/** Sets global error tracking context, e.g a tag with the client identifier */
export const set = (context: Partial<ErrorTrackingContext>) => {
  globalContext = context
}

export const get = () => globalContext
